<template>
    <div class="btn-wrapper text-center">
      <base-button type="neutral" @click="authenticate('facebook')">
        <img slot="icon" src="img/icons/common/facebook.svg">
        Facebook
      </base-button>

      <base-button type="neutral" @click="authenticate('google')">
        <img slot="icon" src="img/icons/common/google.svg">
        Google
      </base-button>
    </div>
</template>
<script>
import { userMixin } from "@/mixins/userMixin";

export default {
  name: "auth-social-component",
  mixins: [userMixin],
  methods: {}
};
</script>
<style>
</style>
